import React from 'react';
import classNames from 'classnames';
import styles from './StatsCardGroup.module.scss';
import StatsCard, { StatsCardProps } from './StatsCard';

interface StatsCardGroupProps {
  stats: StatsCardProps[];
  variant?: 'default' | 'row4';
}

const StatsCardGroup: React.FC<StatsCardGroupProps> = ({ stats, variant = 'default' }) => {
  return (
    <div className={classNames(styles.statsGroup, variant === 'row4' && styles.statsGroup_row4)}>
      {stats.map((stat, index) => (
        <StatsCard key={index} {...stat} />
      ))}
    </div>
  );
};

export default StatsCardGroup;
